import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api, type TicketContract } from '../lib/api';
import { LEVEL, MODEL_LABEL, Meter, h, monthLabel } from '../lib/contracts';

// Etapa 2 · tarjeta "Contrato" del ticket (plegada): saldo del contrato de su iniciativa y, para el
// administrador o el gestor, las horas reales contra las cotizadas del requerimiento.

export function ContractPanel({ number }: { number: string }) {
  const [open, setOpen] = useState(false);
  const q = useQuery({ queryKey: ['ticket-contract', number], queryFn: () => api<TicketContract>(`/tickets/${number}/contract`), enabled: open, staleTime: 60_000 });
  const c = q.data?.contract;
  const qa = q.data?.quoteVsActual;

  return (
    <details className="group rounded-lg border border-line bg-white" onToggle={e => setOpen((e.target as HTMLDetailsElement).open)}>
      <summary className="flex min-h-12 cursor-pointer list-none items-center justify-between gap-2 px-4 [&::-webkit-details-marker]:hidden">
        <span className="flex items-center gap-2">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden="true"
            className="-rotate-90 text-muted transition-transform group-open:rotate-0"><path d="M6 9l6 6 6-6" /></svg>
          <h2 className="text-sm font-semibold">Contrato</h2>
        </span>
        {qa?.over && <span className="rounded bg-[#FBEAEA] px-1.5 py-0.5 text-[11px] font-semibold text-[#8F1D1D]">Sobreconsumo</span>}
      </summary>
      <div className="flex flex-col gap-3 px-4 pb-4 text-sm">
        {q.isLoading && <p className="text-muted">Cargando…</p>}
        {q.isError && <p className="text-[#8F1D1D]">{(q.error as Error).message}</p>}
        {q.data && !c && <p className="text-muted">La iniciativa del ticket no es un contrato de soporte.</p>}
        {c && (
          <div className="flex flex-col gap-2">
            <p className="text-xs text-muted">
              {c.project.code} · {MODEL_LABEL[c.model]}
              {!c.consumesContract && ' · este ticket va a su evolutivo: no consume el contrato'}
            </p>
            {c.bag && <>
              <p className="flex items-baseline justify-between"><span className="font-semibold">{h(c.bag.used)} de {h(c.bag.maxHours)}</span><span className={`text-xs ${LEVEL[c.bag.level].text}`}>quedan {h(c.bag.remaining)}</span></p>
              <Meter pct={c.bag.pct} level={c.bag.level} label="Consumo de la bolsa" />
            </>}
            {c.baseline?.current && <>
              <p className="flex items-baseline justify-between">
                <span className="font-semibold">{h(c.baseline.current.used)} de {h(c.baseline.current.available)}</span>
                <span className={`text-xs ${LEVEL[c.baseline.level].text}`}>{monthLabel(c.baseline.current.month)} · {LEVEL[c.baseline.level].label.toLowerCase()}</span>
              </p>
              <Meter pct={c.baseline.current.available > 0 ? c.baseline.current.used / c.baseline.current.available : 0} level={c.baseline.level} label="Consumo del mes" />
              {c.baseline.projectedExhaustMonth && <p className="text-xs text-[#8F1D1D]">A este ritmo el contrato se agota en {monthLabel(c.baseline.projectedExhaustMonth)}.</p>}
            </>}
            {c.model === 'on_demand' && <p><span className="font-semibold">{h(c.thisMonth.charged)}</span> <span className="text-xs text-muted">en {monthLabel(c.month)} · se factura lo consumido</span></p>}
            {c.canOpen && <Link to={`/contratos/${c.project.id}`} className="w-fit text-xs text-accent underline">Ver el contrato</Link>}
          </div>
        )}
        {qa && (
          <div className={`rounded-md px-3 py-2 ${qa.over ? 'bg-[#FBEAEA] text-[#8F1D1D]' : 'bg-paper text-[#3F3D39]'}`}>
            <p className="font-semibold">{h(qa.actual)} reales de {h(qa.quoted)} cotizadas · {qa.pct} %</p>
            <p className="text-xs">{qa.over
              ? (qa.billing === 'bag' ? 'Pasó lo cotizado en más del 10 %. Al cliente se le descuenta lo cotizado; el excedente lo absorbe Ascendix.' : 'Pasó lo cotizado en más del 10 %. Revisa el tope del evolutivo en Veta.')
              : 'Solo lo ven el administrador y el gestor del servicio.'}</p>
          </div>
        )}
      </div>
    </details>
  );
}
